export const environment = {
    production: false,
    // API_END_POINT: 'http://3da6-14-98-12-178.ngrok.io/kl/GLensClient/',
    // API_END_POINT: 'http://4bb5-2405-204-5601-9c49-9876-24b0-8476-5aa0.ngrok.io',
    // API_END_POINT: 'http://192.168.1.51:7348/kl/GLensClient/',  //139
    // API_END_POINT: 'https://517c-152-58-209-113.ngrok.io/kl/GLensClient/',
    // API_END_POINT: 'http://192.168.1.186:7347/kl/GLensClient/',
    // API_END_POINT: 'http://192.168.1.14:7347/kl/GLensClient/',
    // API_END_POINT: 'http://192.168.1.64:7347/kl/GLensClient/',
    API_END_POINT: '/epda/kl/GLensClient/',
    // API_END_POINT: 'https://epdaportal.glensserver.com/epda/kl/GLensClient/',
    // API_END_POINT: 'https://glensclient.glensweb.com/swcem/kl/GLensClient/',
    // API_END_POINT: 'https://glensclient.glensweb.com/client_revamp/kl/GLensClient/',
    // API_END_POINT: 'http://192.168.0.201/glens_dev/kl/GLensClient/',
    //API_END_POINT: 'http://localhost:7347/kl/GLensClient/',
    SOCKET_END_POINT: 'http://localhost:7677/',
    AQI_API_END_POINT: '/aqi_service/',
    COMPLAINT_API_END_POINT: '/complaints/kl/GLensClient/',
    // AERMOD_API_END_POINT: 'http://192.168.0.217:4400/',
    // AERMOD_API_END_POINT: 'http://localhost:7347/kl/GLensClient/',
    MQTT_CONNECTION: {
        host: '104.211.210.230',
        port: 8083,
        httpsPort: 8084,
        path: ''
    },
    CLIENT_TYPE: 'default',
    R_SHINY_PATH: '/all-analytics/',
    RESTART_SERVICE: '/kl/GLensClientRestart/',
    settings: {
        landingPage: '/landing/realTimeDashboard/slider-dashboard',
        vendorHeader: false,
        logo: 'enviro-sights-white.png',
        vendorLogo: 'industry.png',
        tabTitle: 'EnviroInsights',
        tabIcon: '',
        isYIL: true,
        isBPCL: true,
        clientLogo: 'enviro-sights.png',
        titleLogo: 'enviro-sights.png',
        footerLogo: 'enviro-sights.png',
        mapAPIKey: 'AIzaSyDcvCXAmyYViB3YXDefistdzGptHilc5pI',
        aqiDashboardMapLayers: true,
        exceedanceMarquee: true,
        siteTitle: '',
        manual:'userManual.pdf',
        userRoleTabKeys: [
            'userRole',
            // 'siteId',
            // 'stationList',
            'siteIdList',
            'featureList',
            'setup',
            'dashboard',
            'reports',
            'realTimeDashboard',
            'mapViewDashboard',
            'analyticReports',
            'AQI-Reports',
            'metrologicalReport',
            'calibration',
            'maintenance',
            'utility',
            'diagnostics',
            'comments','landingPage'
        ],
        labelType: 'Site Name',
        staticFilters: {
            month: [
                'time',
                'station',
                'standard'
            ],
            histogramReport: [
                'dateRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter',
                'averageInterval'
            ],
            percentileReport: [
                'dateRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            scatterPlotReport: [
                'dateRange'
            ],
            upTimeReport: [
                'dateRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            polarReport: [
                'dateRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameters'
            ],
            aqiDataReport: [
                'dateRange',
                'stations',
                'standard'
            ],
            windRoseReport: [
                'dateRange',
                // 'station',
                // 'monitoringType',
                // 'monitoringStation',
            ],
            aqiLevelReport: [
                'stations',
                'dateRange',
                'standard'
            ],
            manageComplaints: [
                'calendarRange'
            ],
            listSiteParameter: [
                'station',
                'monitoringType',
                'monitoringStation',
                'parameters',
                'calendarRange'
            ],
            meteorologicalReport: [
                'dateRange',
                'stations',
                'monitoringType',
                'monitoringStation',
                'parameters'
            ],
            metrologicalReport: [
                'dateRange',
                'station'
            ],
            averageSummaryReport: [
                'dateRange'
            ],
            dataAvailabilityDayWiseReport: [
                'calendarRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameters'
            ],
            dataAvailabilityReport: [
                'calendarRange',
                'station',
                'monitoringType',
                'monitoringStations'
            ],
            complaintsInspection: [
                'dateRange'
            ],
            exceedanceCount: [
                'dateRange',
                'station',
                'monitoringTypes',
                'monitoringStations',
                'parameters'
            ],
            exceedenceReport: [
                'dateRange',
                // 'station',
                // 'monitoringTypes',
                // 'monitoringStation',
                // 'parameters',
                // 'standard'
            ],
            parameterSummaryReport: [
                'dateRange'
            ],
            averageReportLoader: [
                'dateRange',
                'station',
                'monitoringTypes',
                'monitoringStations',
                'parameters'
            ],
            diurnalReportLoader: [
                'dateRange',
                'station',
                'monitoringTypes',
                'monitoringStations',
                'parameters'
            ],
            epdaCustomReportLoader: [],
            shiftReport: [
                // 'dateRange',
                'calendarRange',
                'station',
                'monitoringTypes',
                'monitoringStations',
                'parameters'
            ],
            stationWiseReport: [
                'dateRange',
                'station',
                'monitoringTypes',
                'monitoringStations',
            ],
            realtimeDataReport: [
                'dateRange',
                'station'
            ],
            alertSetup: [
                'station'
            ],
            collectorSetup: [
                'station'
            ],
            monitoringStationSetup: [
                'station'
            ],
            parameterSetup: [
                'station'
            ],
            siteConfiguration: [
                'station'
            ],
            alarmReport: [
                'dateRange',
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            maintenanceSetup: [
                'station'
            ],
            systemStatusReport: [
                'station',
                'monitoringType',
                'monitoringStation',
                // 'parameter',
                'dateRange'
            ],
            operatingHours: [
                'station'
            ],
            diagnosticParameter: [
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            diagnostics: [
                // 'station',
                'dateRange',
                // 'monitoringType',
                // 'monitoringStation',
                // 'parameter'
            ],
            calibrationSetup: [
                'station',
            ],
            calibrationLogs: [
                'dateRange'
            ],
            qualityControlCharts: [
                'dateRange'
            ],
            matrixReport: [
                'station',
                // 'dateRange',
                'calendarRange',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            totalizerReport: [
                // 'dateRange'
                'calendarRange',
            ],
            aqiDataEntryList: [
                'dateRange'
            ],
            dailySummaryReport: [
                'station',
                'singleCalendar',
                'monitoringType',
                // 'monitoringStation',
                // 'parameters'
            ],
            monthlySummaryReport: [
                'station',
                // 'singleCalendar',
                'monitoringType',
                // 'monitoringStation',
                // 'parameters'
            ],
            postDataValidation: [
                'station',
                'dateRange',
                'monitoringType',
                'monitoringStation',
                'parameters'
            ],
            dynamicLiveReport: [
                'station',
                'monitoringType',
                'monitoringStation',
                'parameter',
                'dateRange'
            ],
            monthlyReport: [
                'station',
                'monitoringType',
                'monitoringStation',
                'parameters'
            ],
            notification: [
                'station',
                'dateRange',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            normalizationVerification: [
                'station',
                'dateRange',
                'monitoringType',
                'monitoringStation',
                'parameter'
            ],
            aqmsReport: [
                'dateRange'
            ],
            playbackCamera: [
                'dateRange'
            ],
            rainReport: [
                'dateRange'
            ],
            proactiveReport: [
                'dateRange',
                // 'station',
                // 'monitoringType',
                // 'monitoringStations',
                // 'parameters',
                // 'standard'
            ]
        },
        mqttDashboard: false,
        staticFiltersDuplicates: {
            stations: {
                key: 'stations',
                placeholder: 'Site Names',
                bindValue: 'key',
                name: 'Site Names',
                required: true,
                bindLabel: 'label',
                type: 'multiselect',
                options: [],
                dependentOptions: {},
                multipleDependency: true,
                dependencyKeys: [
                    'monitoringType',
                    'monitoringTypes'
                ]
            },
            monitoringTypes: {
                placeholder: 'Monitoring Types',
                type: 'multiselect',
                name: 'Monitoring Types',
                key: 'monitoringTypes',
                options: [],
                required: true,
                bindValue: 'key',
                bindLabel: 'label',
                multipleDependency: true,
                dependencyKeys: [
                    'monitoringStation',
                    'monitoringStations'
                ],
                dependentOptions: {}
            },
            monitoringStations: {
                placeholder: 'Monitoring Stations',
                type: 'multiselect',
                name: 'Monitoring Station',
                key: 'monitoringStations',
                options: [],
                required: true,
                bindValue: 'key',
                bindLabel: 'label',
                multipleDependency: true,
                dependencyKeys: [
                    'parameter',
                    'parameters'
                ],
                dependentOptions: {}
            }
        },
        // By default it is false
        selectAllForFilterModal: true,
        electron: true,
        navHeaderLogo: 'enviro-sights.png',
        activeDirectory: false,
        parameterView: true,
        footerText: 'EnviroInsights 2025 © All rights reserved',
    }
};
